module.exports = __webpack_public_path__ + "static/media/folder-big.52c1b124.svg";